<template>
  <div class="container">
    <h1 v-if="loading" class="no-order text-muted">
      <h2 class="text-muted"><i class="fa fa-spinner fa-spin"></i> Loading...</h2>
    </h1>
    <div v-else id="detail" class="card my-3">
      <div>
        <div 
          class="navbar nav p-4 d-flex justify-content-between align-items-center">
          <div>
            <h4 class="m-0">{{ order.client.nickname }}</h4>
          </div>

          <div>
            <h5 class="m-0">
              Order is 
              <span style="border-bottom: 2px dashed #efefef">{{ order.status.name }}</span>
            </h5>
          </div>
          <div>
            <h5 class="m-0 text-right">
              STORE {{ order.store.id}}<br />
              <span class="badge badge-light">
                REGION {{ order.region.name }}
              </span>
            </h5>
          </div>
          <div>
            <button class="btn btn-sm btn-dark" @click="save">Save</button>
            <router-link class="btn btn-sm btn-dark"
              to="/special-orders">Close</router-link>
          </div>
        </div>

        <div class="">
          <div class="row">
            <div class="col-3 p-4">
              <div class="form-group">
                <label>PO NUMBER</label>
                <input type="text" class="form-control form-control-sm" v-model="order.po_number" />
              </div>
              <div class="form-group">
                <label>ORDER NUMBER</label>
                <input type="text" class="form-control form-control-sm" v-model="order.client_order_number" />
              </div>
            </div>
            <div class="col-3 p-4">
              <div class="form-group">
                <label>CUSTOMER NUMBER</label>
                <input type="text" class="form-control form-control-sm" v-model="order.client_customer_number" />
              </div>
              <div class="form-group">
                <label>CUSTOMER NAME</label>
                <input type="text" class="form-control form-control-sm" v-model="order.client_customer_name" />
              </div>
            </div>
            <div class="col-6 border-left pl-0" style="max-height: 300px;overflow-y: auto;">
              <history-tab :order="order"></history-tab>
            </div>
          </div>
        </div>

        <div class="">
          <ul class="nav nav-tabs">
            <li class="nav-item m-r" style="width: 15px;"></li>
            <li class="nav-item">
              <a class="nav-link active" href="#" data-toggle="tab" data-target="#items">
                  Items
                </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" data-toggle="tab" data-target="#docs">
                Documents
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" data-toggle="tab" data-target="#billable">
                Billable Activity
              </a>
            </li>
          </ul>
        </div>

        <div class="tab-content bg-white">
          <div class="tab-pane active" id="items">
            <items-tab :order="order"></items-tab>
          </div>
          <div class="tab-pane" id="transportation">

            <div class="card-body">
              <div class="row">
                <div class="col-3">
                  <div class="form-group">
                    <label>PO NUMBER</label>
                    <input type="text" class="form-control" v-model="order.po_number" />
                  </div>
                  <div class="form-group">
                    <label>CONTAINER NUMBER</label>
                    <input type="text" class="form-control" v-model="order.container_number" />
                  </div>
                </div>
              </div>
            </div>



          </div>
          <div class="tab-pane" id="docs">
            <docs-tab :order="order"></docs-tab>
          </div>
          <div class="tab-pane" id="billable">
            <billable-tab :order="order"></billable-tab>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  
  import ItemsTab from '@/components/special-orders/ItemsTab'
  import DocsTab from '@/components/special-orders/DocsTab'
  import BillableTab from '@/components/special-orders/BillableTab'
  import HistoryTab from '@/components/special-orders/HistoryTab'
  import api from '@/api'
  export default {
    name: 'special-detail',

    components: {
      ItemsTab,
      DocsTab,
      BillableTab,
      HistoryTab
    },

    data() {
      return {
        loading: false,
        order: { region: {}}
      }
    },

    created() {
      this.fetchData(this.$route.params.id)
    },

    watch: {
      'this.$route.params.id': function(id) {
        this.fetchData(id)
      }
    },

    methods: {
      save() {
        const params = {
          order: {
            po_number: this.order.po_number,
            client_order_number: this.order.client_order_number,
            client_customer_number: this.order.client_customer_number,
            client_customer_name: this.order.client_customer_name,
          }
        }        
        api.post(`/special-orders/${this.order.id}`, params).then(
          this.$router.push('/special-orders')
        )
      },
      
      fetchData(id) {
        this.loading = true
        api.get('/special-orders/' + id).then(res => {
          this.order = res.data.order
          this.loading = false
        })
      }
    }
  }
</script>
<style scoped>
label {
  font-size: 0.75rem;
  color: #666666;
}

.form-control {
  padding-left: 0.5rem;
}
.no-order {
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: space-around;
  height: calc(100vh - 48px);
  flex-direction: column;
}

.no-order h2 {
  justify-self: center;
}
</style>